import { getCookie } from "../../Helper/Cokkies";
import { jwtDecode } from "jwt-decode";
import * as XLSX from 'xlsx'; // Import the xlsx library
import { saveAs } from 'file-saver'; // Import saveAs from file-saver
import axios from "axios";
import { api } from "src/Helper/Data";

export function formValidation(data) {
  let isValid = true;
  data.forEach(el => {
    if (el === "" || el === undefined || el < 1 || el === false) {
      isValid = false;
    }
  });
  if (isValid) {
    return true;
  } else {
    return false;
  }
}

export function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isEmptyObject(data, notInc) {
  let isValid = true;
  let keysArray =  Object.keys(data);
  keysArray.forEach((e)=>{
    if(!notInc.includes(e)){
      if(data[e] === "" || data[e] === undefined || data[e] === null){
        isValid = false
      }
    }
  })
  if (isValid) {
    return true;
  } else {
    return false;
  }  
}

export function userValidate(data, tokenfor) {
  const token = getCookie(tokenfor);
  if (token !== undefined) {
    var decode = jwtDecode(token);
    const role = decode.id.split("-")[1];
    let isValid = false;

    data.forEach(el => {
      if (el === role) {
        isValid = true;
      }
    });
    if (isValid) {
      return true;
    } else {
      return false;
    }
  }
}

export function alcUserValidate(data) {
  const token = getCookie("alcToken");
  if (token !== undefined) {
    var decode = jwtDecode(token);
    const role = decode.id.split("-")[1];
    let isValid = false;

    data.forEach(el => {
      if (el === role) {
        isValid = true;
      }
    });
    if (isValid) {
      return true;
    } else {
      return false;
    }
  }
}

export const makeClickLink = (str) => {
    const check = str.includes("://");
    // const strArray = str.split("//")
  return check ? str : "https://" + str;
}

export function exportToExcel(apiUrl, filename){
    let token = getCookie("token");
      axios
      .post(api.url + apiUrl, apiUrl.params, { headers: { authorization: "Bearer " + token } })
      .then(function (response) {
        response.data.list.forEach((item, index) => {
          item.serial = index + 1;
        });
        // 1. Create a new workbook instance.
      const wb = XLSX.utils.book_new();

      // 2. Convert the JSON data array into a worksheet object.
      const ws = XLSX.utils.json_to_sheet(response.data.list);

      // 3. Add the created worksheet to the workbook.
      XLSX.utils.book_append_sheet(wb, ws, 'UserData');

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' });

      saveAs(data, filename+".xlsx");

      console.log('Excel file generated and downloaded successfully!');

      })
      .catch(function (error) {
        console.log(error);
      });
  };


